<template>
  <el-button-group class="zk-tool-bar">
    <el-button
      v-for="btn of items"
      :size="size || 'small'"
      :title="btn.status === 0 ? this.$t('resource.disabled') : ''"
      :disabled="btn.status === 0"
      :key="btn.id"
      :type="btn.buttonType"
      :round="btn.buttonStyle === 'round'"
      :circle="btn.buttonStyle === 'circle'"
      :plain="btn.buttonStyle === 'plain'"
      @click="emit(btn.resourceEvent)"
      :icon="btn.icon"
    >
      <span v-if="isShowText">{{ getButtonName(btn) }}</span>
    </el-button>
  </el-button-group>
</template>
<script>
export default {
  name: 'ZkToolBar',
  props: ['params', 'size', 'showText'],
  computed: {
    isShowText() {
      if (typeof this.showText === 'undefined') {
        return true
      } else {
        return !!this.showText
      }
    },
    items() {
      try {
        if (this.$root.activeMenu.children) {
          return this.$root.activeMenu.children.filter((item) => {
            return item.resourceType === '3' || item.resourceType === 3
          })
        } else {
          return []
        }
      } catch (error) {}
      return []
    }
  },
  methods: {
    getButtonName(Info) {
      let i18nKey = Info['i18nKey']
      if (i18nKey) {
        let value = this.$t(i18nKey)
        if (value !== i18nKey) {
          return value
        }
      }
      return Info.name
    },
    emit(event) {
      this.$emit(event, this.params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/toolBar/src/main.vue